<template>
    <span class="block text-white text-sm">(max. {{ filesize }} MB)</span>
</template>

<script>
import { fileSizeMaximumValue } from "@/Pages/Media/MediaLibraryLogic";

export default {
    props: ['fileType'],
    data(){
        return {
            filesize: null,
        }
    },
    mounted(){
        this.filesize = fileSizeMaximumValue(this.fileType);
    },
    updated(){
        this.filesize = fileSizeMaximumValue(this.fileType);
    }
}
</script>
